import { cn } from "@/libs/cn";
import { ReactNode } from "react";

interface GridTableScrollProps {
  minWidthClassName?: string;
  className?: string;
  children: ReactNode;
}

interface GridTableCellProps {
  label?: string;
  className?: string;
  children: ReactNode;
}

export const GridTableScroll = ({ minWidthClassName, className, children }: GridTableScrollProps) => (
  <div className={cn("overflow-x-auto", className)}>
    <div className={minWidthClassName}> {children} </div>
  </div>
);

export const GridTableCell = ({ label, className, children }: GridTableCellProps) => (
  <div className={className}>
    {label && <span className="md:hidden block text-sm font-semibold text-gray-500 mb-1">{label}</span>}
    {children}
  </div>
);

export const GridTableEmptyList = () => (
  <div className="bg-white rounded-lg shadow p-8 text-center">
    <p className="italic text-gray-400 text-sm">Nenhum resultado encontrado</p>
  </div>
);
